import React from 'react';
import Card from 'src/components/Card';
import Avatar from 'src/components/Avatar';
import SrDetailContact from 'src/pages/ServiceRequest/components/SrDetailContact/SrDetailContact';
import OpenContactLink from 'src/components/OpenContactLink/OpenContactLink';
import './ServiceRequestHomeOwnerCard.scss';

interface ServiceRequestHomeOwnerCardProps {
  serviceRequest: any;
  loading?: boolean;
  canOpenContact: boolean;
}

const ServiceRequestHomeOwnerCard = ({
  serviceRequest,
  loading,
  canOpenContact,
}: ServiceRequestHomeOwnerCardProps) => {
  if (loading) {
    return (
      <Card
        title="Primary Home Owner"
        body={
          <div className="sr-detail-card-row">
            <SrDetailContact loading name={undefined} />
          </div>
        }
      />
    );
  }

  return (
    <Card
      title="Primary Home Owner"
      body={
        <div className="sr-detail-card-row">
          <SrDetailContact
            name={serviceRequest.suite.homeOwner.name}
            role={serviceRequest.suite.homeOwner.role}
            email={serviceRequest.suite.homeOwner.email}
            phone={serviceRequest.suite.homeOwner.phone}
            avatar={
              <Avatar
                url={serviceRequest.suite.homeOwner.profileImage}
                badge={undefined}
                size={undefined}
              />
            }
          />
          {canOpenContact && serviceRequest.suite.homeOwner.id && (
            <OpenContactLink
              userId={serviceRequest.suite.homeOwner.id}
              name={serviceRequest.suite.homeOwner.name}
              navOrigin={{
                kind: 'serviceRequest',
                serviceRequestId: serviceRequest.id,
              }}
            />
          )}
        </div>
      }
    />
  );
};

export default ServiceRequestHomeOwnerCard;